// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  GenericApiResponseListScheduledChangeSummary,
  GenericApiResponseScheduledChangeDetail,
  HTTPValidationError,
  ScheduledChangeSwapRequest,
} from '../../models';

/**
 * @summary List Scheduled Changes
 */
export const listScheduledChanges = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListScheduledChangeSummary>> => {
  return axios.get(`/scheduled-changes`, options);
};

export const getListScheduledChangesQueryKey = () => {
  return [`/scheduled-changes`] as const;
};

export const getListScheduledChangesQueryOptions = <
  TData = Awaited<ReturnType<typeof listScheduledChanges>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduledChanges>>, TError, TData>>;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListScheduledChangesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listScheduledChanges>>> = ({ signal }) =>
    listScheduledChanges({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listScheduledChanges>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListScheduledChangesQueryResult = NonNullable<Awaited<ReturnType<typeof listScheduledChanges>>>;
export type ListScheduledChangesQueryError = AxiosError<void>;

export function useListScheduledChanges<
  TData = Awaited<ReturnType<typeof listScheduledChanges>>,
  TError = AxiosError<void>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduledChanges>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof listScheduledChanges>>, TError, TData>, 'initialData'>;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListScheduledChanges<
  TData = Awaited<ReturnType<typeof listScheduledChanges>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduledChanges>>, TError, TData>> &
    Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof listScheduledChanges>>, TError, TData>, 'initialData'>;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListScheduledChanges<
  TData = Awaited<ReturnType<typeof listScheduledChanges>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduledChanges>>, TError, TData>>;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Scheduled Changes
 */

export function useListScheduledChanges<
  TData = Awaited<ReturnType<typeof listScheduledChanges>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduledChanges>>, TError, TData>>;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListScheduledChangesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Scheduled Change
 */
export const getScheduledChange = (
  changeId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseScheduledChangeDetail>> => {
  return axios.get(`/scheduled-changes/${changeId}`, options);
};

export const getGetScheduledChangeQueryKey = (changeId: string) => {
  return [`/scheduled-changes/${changeId}`] as const;
};

export const getGetScheduledChangeQueryOptions = <
  TData = Awaited<ReturnType<typeof getScheduledChange>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  changeId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledChange>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetScheduledChangeQueryKey(changeId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getScheduledChange>>> = ({ signal }) =>
    getScheduledChange(changeId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!changeId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getScheduledChange>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetScheduledChangeQueryResult = NonNullable<Awaited<ReturnType<typeof getScheduledChange>>>;
export type GetScheduledChangeQueryError = AxiosError<void | HTTPValidationError>;

export function useGetScheduledChange<
  TData = Awaited<ReturnType<typeof getScheduledChange>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  changeId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledChange>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getScheduledChange>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetScheduledChange<
  TData = Awaited<ReturnType<typeof getScheduledChange>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  changeId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledChange>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getScheduledChange>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetScheduledChange<
  TData = Awaited<ReturnType<typeof getScheduledChange>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  changeId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledChange>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Scheduled Change
 */

export function useGetScheduledChange<
  TData = Awaited<ReturnType<typeof getScheduledChange>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  changeId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledChange>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetScheduledChangeQueryOptions(changeId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Swap Scheduled Change Question
 */
export const swapScheduledChangeQuestion = (
  changeId: string,
  scheduledChangeSwapRequest: ScheduledChangeSwapRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseScheduledChangeDetail>> => {
  return axios.post(`/scheduled-changes/${changeId}/swaps`, scheduledChangeSwapRequest, options);
};

export const getSwapScheduledChangeQuestionMutationOptions = <
  TData = Awaited<ReturnType<typeof swapScheduledChangeQuestion>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { changeId: string; data: ScheduledChangeSwapRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['swapScheduledChangeQuestion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof swapScheduledChangeQuestion>>,
    { changeId: string; data: ScheduledChangeSwapRequest }
  > = (props) => {
    const { changeId, data } = props ?? {};

    return swapScheduledChangeQuestion(changeId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { changeId: string; data: ScheduledChangeSwapRequest },
    TContext
  >;
};

export type SwapScheduledChangeQuestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof swapScheduledChangeQuestion>>
>;
export type SwapScheduledChangeQuestionMutationBody = ScheduledChangeSwapRequest;
export type SwapScheduledChangeQuestionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Swap Scheduled Change Question
 */
export const useSwapScheduledChangeQuestion = <
  TData = Awaited<ReturnType<typeof swapScheduledChangeQuestion>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { changeId: string; data: ScheduledChangeSwapRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { changeId: string; data: ScheduledChangeSwapRequest }, TContext> => {
  const mutationOptions = getSwapScheduledChangeQuestionMutationOptions(options);

  return useMutation(mutationOptions);
};
